import styled from "styled-components";
import {DataScope, Job, Person, Profile, StyledBaseProps} from "@betrue/shared/interfaces";
import {Avatar, Badge, Grid, IconButton, Link, Typography} from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import * as React from "react";
import {ProfileAvatarEditor, ProfileAvatarEditorProps, ProfileContainerProps, ProfileModal} from "@betrue/ui";
import {personAvatarUrl} from "@betrue/front/services";
import {UserRatingView} from "../user-rating/user-rating.view";
import {AdminZone} from "../admin-zone/admin-zone";

export interface ProfileViewProps extends StyledBaseProps, ProfileContainerProps, ProfileAvatarEditorProps {
    onFirstNameSubmit: (fn: string) => void;
    onLastNameSubmit: (fn: string) => void;
    priceSubmit: (fn: number) => void;
    onJobDelete?: (job: Job) => void
    profile: Profile,
    person: Person,
    principal:Person,
    onAvatarClick: () => void,
    component?: React.ElementType,
    onRatingUpdated: (v: Profile['rating']) => void

}

export interface ProfileJobTitleViewProps extends StyledBaseProps {
    onDelete?: (job: Job) => void
    job: Job,
    component?: React.ElementType
    noJobLabel: string

}


export const ProfileJobTitleView = styled((props: ProfileJobTitleViewProps) => (
    <span className={props.className}>
    <Grid container alignContent={"center"} direction="row" justifyContent="center" alignItems="center">
        {props.job ?
            (<><Typography className={'job-title-label'} component={"h4"}>{props.job.label}</Typography>
                {props.onDelete ?
                    (
                        <IconButton aria-label="delete" onClick={() => props.onDelete(props.job)}>
                            <DeleteOutlineIcon fontSize="small"/>
                        </IconButton>
                    )
                    : ''
                }</>) : <Typography className={'job-title-label'}
                                    component={"h4"}>{props.noJobLabel ? props.noJobLabel : 'No Job :('}</Typography>}
    </Grid>
  </span>
))`
  & .job-title-label {
    color: ${props => props.theme.colors.accent};
    font-size: 24px;
  }
`
const StyledBadge = styled(Badge)(({theme}) => ({
    '& .MuiBadge-badge': {
        backgroundColor: `${theme.colors.text}`,
        color: `${theme.colors.text}`,
        boxShadow: `0 0 0 2px `,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '1px solid currentColor',
            content: '""',
        },
    }

}));
export const ProfileView = styled((props: ProfileViewProps) => (
    <span className={props.className}>
    <ProfileAvatarEditor {...props}/>
    <Grid container alignContent={"center"} spacing={1} direction="column" justifyContent="center" alignItems="center">
        <AdminZone principal={props.principal} subject={props.person}><Grid item>
            <UserRatingView
                onRating={props.onRatingUpdated}
                readOnly={false}
                defaultValue={props.profile.rating != undefined ? props.profile.rating : 2}/>
        </Grid>
          </AdminZone>
      <Grid item>
        <StyledBadge
            onClick={props.onAvatarClick}
            overlap="circular"
            className={'can-edit'}
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            variant={"standard"}
            badgeContent={<span>{props.profile.available ? '🌞' : '🌛'}</span>}>
            <Avatar alt={`${props.person.firstName} ${props.person.lastName}`}
                    src={personAvatarUrl(props.person)}
                    className={'avatar'}>
              {
                  props.person.firstName && props.person.lastName ?
                      props.person.firstName[0] + props.person.lastName[0] :
                      '??'
              }
            </Avatar>
        </StyledBadge>
      </Grid>
      <Grid item>
        <Typography
            component={"h4"}>{
            props.person.firstName ?
                props.person.firstName :
                `${props.firstNameLabel} ?`
        }</Typography>

      </Grid>
      <Grid item>
       <Typography
           component={"h4"}>{
           props.person.lastName ?
               props.person.lastName :
               `${props.lastNameLabel} ?`
       }</Typography>
      </Grid>
      <Grid item>
      <ProfileJobTitleView noJobLabel={props.noJobLabel} component={props.component} onDelete={props.onJobDelete}
                           job={props.profile.job}/>
      </Grid>
      <Grid item>
        <Grid container direction={"row"} spacing={1}>
          <Grid item>
          {props.profile.portfolio ?
              (<Typography component={"h3"}>
                  <Link href={props.profile.portfolio.startsWith('https://') ||
                  props.profile.portfolio.startsWith('http://') ? props.profile.portfolio :
                      `https://${props.profile.portfolio}`} target={"_blank"} underline={"none"}>
                      {props.portfolioLabel}
                  </Link></Typography>) :
              (<Typography component={"h4"}>{`${props.portfolioLabel}`}</Typography>)
          }
          </Grid>
          <Grid item>
            {props.person.email ?
                (<Typography component={"h3"}><Link href={`mailto: ${props.person.email}`} target={"_blank"}
                                                    underline={"none"}>
                    @
                </Link></Typography>) :
                ('')
            }
          </Grid>
        </Grid>

      </Grid>
       <Grid item>
        <Typography component={"h4"}>
          {props.profile.price ? `${props.profile.price} €/Jour` : `${props.priceLabel} ?`}
        </Typography>
       </Grid>

       <Grid item>
      <ProfileModal
          portfolioLabel={props.portfolioLabel}
          submitButton={props.submitButton}
          dialogHeader={props.dialogHeader}
          phoneLabel={props.phoneLabel}
          cancelButton={props.cancelButton}
          dialogDescription={props.dialogDescription}
          firstNameLabel={props.firstNameLabel}
          lastNameLabel={props.lastNameLabel}
          emailLabel={props.emailLabel}
          priceLabel={props.priceLabel}
          availabilityLabel={props.availabilityLabel}/>
       </Grid>
    </Grid>
  </span>
))`
  & .avatar {
    width: ${props => props.theme.spacing(15)};
    height: ${props => props.theme.spacing(15)};

  }

  & .can-edit {
    cursor: pointer;
  }

  & div {
    text-align: center;
  }

  & h4 {
    color: ${props => props.theme.colors.secondary};
    font-size: 24px;
    font-weight: normal;
  }
`;

